/// <reference path="index.d.ts" />

import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import wrapAxios from 'zipkin-instrumentation-axiosjs';

import { envs } from 'application/envHandler';
import { ACCESS_TOKEN_KEY } from 'core/auth/constants';
import { ConsoleRecorder, ExplicitContext, Tracer } from 'zipkin';
import AuthService from '../auth/auth-service';

const ctxImpl = new ExplicitContext();
const recorder = new ConsoleRecorder();
const localServiceName = 'vipoc-fe-react';
const remoteServiceName = 'vipoc-fe-nodejs';

const tracer = new Tracer({ ctxImpl, recorder, localServiceName });

export class ApiClient {
  private client: AxiosInstance = wrapAxios(Axios.create(), { tracer, remoteServiceName });

  constructor(accessTokenKey: string) {
    this.client.interceptors.request.use(request => {
      const idToken = localStorage.getItem(accessTokenKey);
      const currentUser = AuthService.getCurrentUser();

      if (
        request.method !== 'get' &&
        (request.url?.includes('command') ||
          request.url?.includes('remove') ||
          request.url?.includes('change-parental-pin') ||
          request.url?.includes('activity-log')) &&
        !currentUser.groups.some(
          (it) =>
            it.prefix === 'module' &&
            it.moduleName === 'devices' &&
            it.role === 'su' &&
            it.opco === AuthService.getCurrentOpco()
        )
      ) {
        return Promise.reject(new Error('error_messages.permission_denied'));
      }
      if (!request.headers.ignoreCommonHeaders) {
        request.headers.token = idToken;
        request.headers.opco = AuthService.getCurrentOpco();
      }

      return request;
    });

    this.client.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
          if (!envs.REACT_APP_IS_LOCAL) {
            AuthService.logoutAndRedirect()
          }
        }

        return Promise.reject(error);
      }
    );
  }

  public get(url: string, config?: AxiosRequestConfig) {
    return this.client.get(url, config);
  }

  public post(url: string, data?: any, config?: AxiosRequestConfig) {
    return this.client.post(url, data, config);
  }

  public put(url: string, data: any, config?: AxiosRequestConfig) {
    return this.client.put(url, data, config);
  }

  public delete(url: string, data?: any, config?: AxiosRequestConfig) {
    return this.client.delete(url, { data, ...config });
  }
}

export default new ApiClient(ACCESS_TOKEN_KEY);
